module.exports = __webpack_public_path__ + "static/psychadeliccat-2c4f9f9f475caad907b60a268f008ca5.gif";